import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-history",
  "use": "icon-history-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-history\">\n<g id=\"icon-history_&#229;&#142;&#134;&#229;&#143;&#178;1\">\n<g id=\"icon-history_Group 3640\">\n<path id=\"icon-history_Vector\" d=\"M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z\" />\n<path id=\"icon-history_Vector_2\" d=\"M11 7V13H17\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol